import React, { useEffect, useMemo, useState } from "react";
import { DirectionRight } from "@/Icons";
import { EmptyState, Radio, Toast } from "@ad/anq-ui";
import { ResourceCodeEnums } from "@/api/dmp_common/interface";
import DataOverviewCard from "../components/data_overview_card";
import { isEmptyBusinessData } from "views/menu_layout/gmv_overview/util";
import { queryBusinessData } from "@/api/business_gmv";
import { QueryBusinessDataResult } from "@/api/business_gmv/interface";
import {
  BACKEND_FORMAT,
  CAN_SELECT_TIME_LIST,
  FRONTEND_FORMAT,
  cardList,
  getStartEndTime,
} from "../common";
import Chart from "../components/business_chart";
import { useAuth } from "@/common/hooks/use_auth";

/** 首页生意模块 */
const Business = () => {
  const [hasAuth] = useAuth(ResourceCodeEnums.BUSINESS_DATA);

  const [selectedCardKey, setSelectedCardKey] = useState<string>(
    cardList[0].key
  );
  // 近几日时间范围
  const [timeRange, setTimeRange] = useState(90);
  const [businessData, setBusinessData] = useState<QueryBusinessDataResult>();

  const selectedCard = useMemo(() => {
    return cardList.find((item) => item.key === selectedCardKey);
  }, [selectedCardKey]);

  useEffect(() => {
    if (timeRange && hasAuth) {
      getBusinessData();
    }
  }, [timeRange]);

  const handleJump = () => {
    window.open(
      `/${ResourceCodeEnums.BUSINESS}?menu=${ResourceCodeEnums.BUSINESS_DATA}`
    );
  };

  const getBusinessData = async () => {
    const res = await queryBusinessData({
      authMallId: 0,
      brandId: 0,
      cate2Id: 0,
      startTime: getStartEndTime(timeRange).startTime.format(BACKEND_FORMAT),
      endTime: getStartEndTime(timeRange).endTime.format(BACKEND_FORMAT),
    });

    if (res.success) {
      setBusinessData(res.result);
    } else {
      Toast.error(res.errorMsg || "获取数据失败");
    }
  };

  return (
    <div className="mt-4 rounded-lg bg-white p-6">
      <div className="title mb-6 overflow-hidden">
        <span className="text-base font-semibold leading-8">生意</span>
        <div className="title-tools float-right flex">
          <span className="mr-3 leading-8 text-text-black/[.65]">
            统计时间：
            {getStartEndTime(timeRange).startTime.format(
              FRONTEND_FORMAT
            )} ~ {getStartEndTime(timeRange).endTime.format(FRONTEND_FORMAT)}
          </span>
          <Radio.Group
            value={timeRange}
            onChange={(e) => setTimeRange(e.target.value)}
          >
            {CAN_SELECT_TIME_LIST.map((item) => (
              <Radio.Button key={item} value={item}>
                {item === 1 ? "昨日" : `近 ${item} 日`}
              </Radio.Button>
            ))}
          </Radio.Group>
          <span
            className="dmp-link ml-4 flex h-8 cursor-pointer items-center text-text-black/[.65]"
            onClick={handleJump}
          >
            查看更多
            <DirectionRight />
          </span>
        </div>
      </div>

      <div className="flex gap-6">
        <div className="flex-1">
          <DataOverviewCard
            items={cardList.map((item) => ({
              tooltip: item.notice,
              ...item,
            }))}
            selectedKey={selectedCardKey}
            onSelect={setSelectedCardKey}
            dataSource={businessData}
            hideSelectBar
            className="gap-x-4 gap-y-3"
            col={3}
          />
        </div>
        <div className="flex-1">
          <div className="h-[240px] w-full">
            {isEmptyBusinessData(businessData) ? (
              <div className="pt-[76px]">
                <EmptyState description="暂无数据" />
              </div>
            ) : (
              <Chart
                selectedCard={selectedCard}
                businessData={businessData}
                hideLegend
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Business;
